import React from 'react'
import {Navigate, Outlet, Route, Routes, useLocation} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {AccountHeader} from './AccountHeader'
import {All} from './components/All'
import {Active} from './components/Active'
import {Verified} from './components/Verified'
import {Pending} from './components/Pending'
import {Rejected} from './components/Rejected'
import VendorDetailPage from '../vendordetail/VendorDetailPage'
import {Inactive} from './components/Inactive'
import {Tr} from '../../../_metronic/i18n/Tr'
import {  getEncryptedRoute, useMenuIdPermissions} from '../../../reusable'

const AccountPage: React.FC = () => {
  let t = Tr()
  const location = useLocation()
  const {urlData , menuId} = useMenuIdPermissions()

  const accountBreadCrumbs: Array<PageLink> = [
    {
      title: t('Vendors'),
      path:
        getEncryptedRoute("/viewvendor/all",{menuId :menuId}),
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <Routes>
      <Route
        element={
          <>
            <AccountHeader menuId={menuId} />
            <Outlet />
          </>
        }
      >
        <Route
          path={'all'}
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>{t('All')}</PageTitle>
              <All />
            </>
          }
        />
        <Route
          path='active'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>{t('Active')}</PageTitle>
              <Active />
            </>
          }
        />
        <Route
          path='inactive'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>{t('Inactive')}</PageTitle>
              <Inactive />
            </>
          }
        />
        <Route
          path='verified'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>{t('Verified')}</PageTitle>
              <Verified />
            </>
          }
        />
        <Route
          path='pending'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>{t('Pending')}</PageTitle>
              <Pending />
            </>
          }
        />
        <Route
          path='rejected'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>{t('Rejected')}</PageTitle>
              <Rejected />
            </>
          }
        />

        <Route index element={<Navigate to={getEncryptedRoute("/viewvendor/all",{menuId :menuId})} />} />
      </Route>
      <Route
        path='vendordetail/*'
        element={
          <>
            <PageTitle breadcrumbs={accountBreadCrumbs}>{t('Vendor Detail')}</PageTitle>
            <VendorDetailPage />
          </>
        }
      />
    </Routes>
  )
}

export default AccountPage
